import { IsConnectionSecure } from "../../../Syntess.Web.Shared/Utils/Browser";

export class CookieUtils {
    public static setCookie(name: string, value: string, expiresInDays?: number) {
        let options: Cookies.CookieAttributes =
        {
            sameSite: "none",
            expires: expiresInDays
        }

        if (IsConnectionSecure()) {
            options.secure = true;
        }

        Cookies.set(name, value, options)
    }
}
